import Vue from 'vue';
import __vue_component__$2 from './TmdBadge.js';
import __vue_component__$3 from './TmdIcon.js';
import __vue_component__$1 from './MdInkRipple.js';
import { M as MdElevation } from './MdElevation-c5881c4e.js';
import MdTheme from './MdTheme.js';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

var script = Vue.extend({
  name: "tmd-button",
  components: {
    MdInkRipple: __vue_component__$1,
    TmdBadge: __vue_component__$2,
    TmdIcon: __vue_component__$3
  },
  mixins: [MdElevation, MdTheme],
  props: {
    href: String,
    target: String,
    rel: String,
    type: {
      type: String,
      default: "button"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableRipple: {
      type: Boolean,
      default: false
    },
    borderStyle: {
      type: String,
      default: "thinner",
      validator: val => ["thinner", "thicker", "none"].includes(val)
    },
    mdParentElevation: {
      type: String,
      required: false,
      validator: val => ["0", "1", "2", "theme", "brand", "error"].includes(val)
    },
    prependIcon: {
      type: String,
      required: false
    },
    fillIcon: {
      type: Boolean,
      default: true
    },
    iconMargin: {
      type: [Number, String],
      default: "8px"
    },
    minWidth: {
      type: [Number, String],
      default: "64px"
    },
    stacked: {
      type: Boolean,
      default: false
    },
    badge: {
      type: Number,
      required: false
    },
    wrapContent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tag: this.href ? "a" : "button",
      buttonType: !this.href && (this.type || "button")
    };
  },
  computed: {
    styleClasses() {
      return ["tmd-button", {
        "tmd-button--thicker-border": this.borderStyle === "thicker",
        "tmd-button--thinner-border": this.borderStyle === "thinner",
        "tmd-has-prepend": this.prependIcon || !!this.$slots.prepend,
        "tmd-stacked": this.stacked,
        "tmd-wrap-content": this.wrapContent
      }, this.$mdActiveElevation, this.$mdActiveTheme, this.$tmdActiveTheme, this.parentElevation];
    },
    newRel() {
      if (this.target === "_blank") {
        return this.rel || "noopener";
      }
      return this.rel;
    },
    parentElevation() {
      return this.mdParentElevation ? `md-parent-elevation-${this.mdParentElevation}` : undefined;
    }
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
    onMouseOver(event) {
      this.$emit("mouseover", event);
    }
  },
  render(createElement) {
    var _this$$vnode$data, _this$$vnode$data2;
    const children = this.$slots.default;
    const prependSlot = this.$slots.prepend;
    const ripple = this.disableRipple ? undefined : createElement("md-ink-ripple", {
      props: {
        mdDisabled: this.disabled
      }
    });
    const prependIcon = this.prependIcon && !prependSlot ? createElement(__vue_component__$3, {
      props: {
        fill: this.fillIcon
      }
    }, [this.prependIcon]) : undefined;
    const prependSlotContent = prependSlot ? prependSlot : undefined;
    const button = createElement(this.tag, {
      staticClass: (_this$$vnode$data = this.$vnode.data) === null || _this$$vnode$data === void 0 ? void 0 : _this$$vnode$data.staticClass,
      class: this.styleClasses,
      style: (_this$$vnode$data2 = this.$vnode.data) === null || _this$$vnode$data2 === void 0 ? void 0 : _this$$vnode$data2.style,
      staticStyle: {
        "--button-min-width": typeof this.minWidth === "number" ? `${this.minWidth}px` : this.minWidth,
        "--button-icon-margin": typeof this.iconMargin === "number" ? `${this.iconMargin}px` : this.iconMargin
      },
      attrs: {
        href: this.href,
        target: this.target,
        rel: this.newRel,
        type: this.buttonType,
        disabled: this.disabled
      },
      on: {
        click: this.onClick,
        mouseover: this.onMouseOver
      }
    }, [ripple, prependIcon, prependSlotContent, createElement("span", {
      staticClass: "tmd-button__content"
    }, children)]);
    return this.badge ? createElement(__vue_component__$2, {
      props: {
        value: this.badge,
        position: this.stacked ? {
          top: "4px",
          right: "calc(50% - 32px)"
        } : undefined
      },
      style: {
        height: "100%",
        display: "flex"
      }
    }, [button]) : button;
  }
});

const __vue_script__ = script;
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-03f6b812_0", {
    source: "button[data-v-03f6b812]:focus{outline:0}.tmd-button[data-v-03f6b812]{min-width:var(--button-min-width);min-height:36px;padding:0 16px;display:inline-grid;gap:var(--button-icon-margin);align-items:center;justify-content:center;justify-items:center;align-content:center;position:relative;user-select:none;cursor:pointer;outline:0;background:0 0;border:0;transition:all .4s cubic-bezier(.25,.8,.25,1);text-align:center;text-decoration:none;vertical-align:top;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.tmd-button__content[data-v-03f6b812]{padding:4px 0;line-height:normal}.tmd-stacked .tmd-button__content[data-v-03f6b812]{padding:0}.tmd-button.tmd-wrap-content[data-v-03f6b812]{white-space:normal}.tmd-button.tmd-has-prepend[data-v-03f6b812]:not(.tmd-stacked){grid-template-areas:\"prepend content\"}.tmd-button.tmd-stacked[data-v-03f6b812]{gap:4px}.tmd-button[data-v-03f6b812]:not([disabled]){cursor:pointer}.tmd-button:not([disabled]).md-focused[data-v-03f6b812]:before,.tmd-button[data-v-03f6b812]:not([disabled]):active:before,.tmd-button[data-v-03f6b812]:not([disabled]):hover:before{background-color:currentColor;opacity:.12}.tmd-button[data-v-03f6b812]:not([disabled]):active:before{opacity:.2}.tmd-button:not([disabled]).md-ripple-off[data-v-03f6b812]:active:before{opacity:.26}.tmd-button.tmd-raised[data-v-03f6b812]{border-radius:18px}.tmd-button.tmd-raised .md-ink-ripple[data-v-03f6b812]{border-radius:18px!important}.tmd-button.tmd-raised.tmd-button--thicker-border[data-v-03f6b812]{border:3px solid currentColor}.tmd-button.tmd-raised.tmd-button--thinner-border[data-v-03f6b812]:not(.tmd-icon-button){padding-top:2px;padding-bottom:2px}.tmd-button.tmd-raised.tmd-button--thinner-border[data-v-03f6b812]:not(.tmd-icon-button):after{content:\"\";display:block;position:absolute;top:2px;bottom:2px;left:2px;right:2px;border:1px solid currentColor;border-radius:18px}.tmd-button[data-v-03f6b812]:active{outline:0}.tmd-button[data-v-03f6b812]::-moz-focus-inner{padding:0;border:0}.tmd-button[data-v-03f6b812]:before{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;opacity:0;transition:.4s cubic-bezier(.4,0,.2,1);will-change:background-color,opacity;content:\" \"}.tmd-button[disabled][data-v-03f6b812]{cursor:default;pointer-events:none}.tmd-button .md-ripple[data-v-03f6b812]{padding:0 8px;display:flex;justify-content:center;align-items:center}.tmd-button.tmd-icon-button[data-v-03f6b812]{border-radius:50%;width:40px;min-width:40px;height:40px;padding:0}.tmd-button.tmd-icon-button .md-ripple-enter-active[data-v-03f6b812]{transition-duration:1.2s}.tmd-button.tmd-icon-button[data-v-03f6b812]:before{border-radius:50%}.tmd-button.tmd-icon-button .md-ripple[data-v-03f6b812]{border-radius:50%}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = "data-v-03f6b812";
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = undefined;
const __vue_component__ = normalizeComponent({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
